import { TefComs4cs4p } from '@mfe/components/TefComs4cs4p';
import { Purpose } from '@mfec/types/model';
import { html } from 'lit';

//
// renders a single USER BOUND purpose block
//
export const singlePurposeUserBound = function render(this: TefComs4cs4p, purpose : Purpose)
  : ReturnType<typeof html> {
  return html`
    <section class="section section--prio-bg-2 section--size-flat u-block-centered">
      <div class="typography-display--6 u-sb--flat" align="center">Vertragsinhaber</div>
    </section>

    <div class="container">
      ${purpose.apps!.map((app) => this.getTemplateFn('singleAppConsent')(app))}
    </div>`;
};
